import styled from "styled-components";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledToggleButton = styled(ToggleButton)`
    flex: 1;

    background: var(--color-white);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    color: var(--color-grey-800);
    font-size: 1.6rem;

    border-radius: var(--radius-5);

    &.MuiToggleButtonGroup-grouped:not(:first-of-type) {
        border-top-left-radius: var(--radius-5);
        border-bottom-left-radius: var(--radius-5);
    }

    &.MuiToggleButtonGroup-grouped:not(:last-of-type) {
        border-top-right-radius: var(--radius-5);
        border-bottom-right-radius: var(--radius-5);
    }

    &:focus,
    &:hover {
        background-color: var(--color-grey-400);
    }

    &.Mui-selected {
        ${({ selected, theme }) => {
            if (selected) {
                return theme.components.MuiButton.styleOverrides.containedPrimary;
            }
        }}
    }

    text-transform: none;
    padding: 6px 16px;
`;

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
    display: flex;
    gap: 20px;

    @media ${breakpoints.sm} {
        flex-direction: column;
    }
`;
